<block-ui>
  <router-outlet></router-outlet>
</block-ui>
<app-error-popup #errorPopup></app-error-popup>
